<template>
    <div class="ku-food">

        <!-- 套餐商品 -->
        <div class="ku-combo">
            <div class="grid" v-for="(vo, key) in comboList" :key="key">
                <div class="s1" @click="addCombo(vo, $event)">
                    <span>{{ vo.name }}</span>
                    <span><label>&yen;</label>{{ vo.price }}</span>
                    <span>点击进购物车</span>
                </div>
                <div class="s2">
                    <div class="s-1" v-for="(item, index) in vo.list" :key="index" @click="xGoods(item, key)">
                        <van-image :src="item.price_list.image" fit="cover" />
                        <span>{{ item.price_list.name }}</span>
                        <span>选项{{ index+1 }}</span>
                    </div>
                </div>
                <div class="s3" v-for="(v3, i3) in vo.list" :key="i3" v-show="v3.show">
                    <div class="back_a"></div>
                    <div class="s3-goods">
                        <div class="s-1" v-for="(v3_1, i3_1) in v3.list" :key="i3_1" @click="v3Goods(v3_1, i3, key)">
                            <van-image :src="v3_1.image" fit="cover" />
                            <span>{{ v3_1.name }}</span>
                            <van-icon name="success" v-show="v3.price_list.id === v3_1.id" />
                        </div>
                    </div>
                    <div class="v3-raise">
                        <div class="s-1" v-for="(v3_raise, i3_raise) in vo.price_list" :key="i3_raise" @click="v3GoodsRaise(v3_raise, i3_raise, key, i3)">
                            <span :class="v3_raise.active ? 'active' : ''">{{ v3_raise.name }} {{ v3_raise.price > 0 ? parseFloat(v3_raise.price) + '元' : '' }}</span>
                        </div>
                    </div>
                    <van-button round type="primary" @click="v3.show = false">确定</van-button>
                </div>
            </div>
        </div>

        <!-- 商品 -->
        <div class="ku-list">
            <van-grid class="grid" column-num="3">
                <van-grid-item v-for="(item, index) in goodsList" :key="index" @click="addOne(item, $event)" :class="item.img === '' ? 'image_text' : ''">
                    <van-image :src="item.img" fit="cover" />
                    <span class="title">{{ item.name }}</span>
                    <span class="price"><label>&yen;</label>{{ item.price }}</span>
                </van-grid-item>
            </van-grid>
        </div>

        <div class="buy">
            <div class="but-1" v-if="shop.checkTime" @click="delCart">特惠早餐</div>
            <div class="cen" v-if="shop.checkTime" @click="buy" ref="cart">
                <div :class="shop.min_fee > 0 && coType === '2' ? 's1' : 's1 no'">
                    <span>选好了</span>
                    <label>{{ shop.min_fee }}元起送</label>
                </div>
                <div class="s2">{{ total }}元</div>
            </div>
            <div class="but-1" @click="onHref(2)">更多餐品</div>
        </div>

        <van-popup v-model="oneShow" class="onePop">
            <div class="back_a"></div>
            <div class="s1">{{ onePop.name }}</div>
            <div class="v3-raise">
                <div class="s-1" v-for="(vo, index) in onePop.raise" :key="index" @click="onePopActive(index)">
                    <span :class="vo.active ? 'active' : ''">{{ vo.name }} {{ vo.price > 0 ? parseFloat(vo.price) + '元' : '' }}</span>
                </div>
            </div>
            <van-button round type="primary" @click="addOneOk">确定</van-button>
        </van-popup>

        <transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
            <div class="ball" v-show="ballFlag" v-cloak ref="ball" :style="{top: `${tt}px`,left:`${ll}px`}"></div>
        </transition>

        <van-empty v-if="showEmpty && shop.checkTime === false" description="店铺不在早餐营业时间" />

        <van-popup v-model="showPopup" class="csss">
            <van-loading type="spinner" />
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import {Grid, Button, GridItem, Image as VanImage, Notify, Popup, Icon, Empty } from 'vant';
import {getCookie, setCookie} from "@/utils/auth";

Vue.use(Grid).use(GridItem).use(VanImage).use(Button).use(Notify).use(Popup).use(Icon).use(Empty);

export default {
    name: "GoodsFast",
    data() {
        return {
            shop_id: 0,
            shop: [],
            food_tab: [],
            coType: 1,
            tab_num: 0,
            click_id: 0,

            showEmpty: false,
            showPopup: true,

            comboList: [],
            goodsList: [],

            card: [],
            cart: [],
            total: 0,
            oneShow: false,
            onePop: [],

            tt:0,//小球因为自适应需要重新设置top值
            ll:0,
            ballFlag: false
        }
    },
    mounted() {
        this.shop_id = this.$route.query.shop_id
        let that = this
        that.coType = getCookie('coType')
        let cart = getCookie('cart_' + this.shop_id) || '';
        if (cart !== 'undefined' && cart !== '') {
            let cart_time = getCookie('cart_time_' + this.shop_id)
            if (cart_time !== 'undefined' && cart_time !== '') {
                cart_time = parseInt(cart_time)
                let time = Math.round(new Date().getTime()/1000)
                if ((cart_time + 60 * 60 *10) > time) {
                    that.cart = JSON.parse(cart)
                } else {
                    that.cart = []
                }
            } else {
                that.cart = []
            }
        }

        this.getGoodComboList()
    },
    methods: {
        onHref(type) {
            if (type === 2) {
                this.$router.push('/goods?shop_id=' + this.shop_id);
            }
        },
        delCart() {
            // setCookie('cart_' + this.shop_id);
            // Notify({ type: 'success', message: '尝试清空购物车',duration: 1000 });
        },
        getGoodList(one) {
            let that = this
            one.forEach(function (item) {
                item.list.forEach(function (vo) {
                    that.goodsList.push(vo)
                });
            })

            this.$API.getShopInfo({shop_id: that.shop_id}).then(res => {
                return res.data
            }).then(res => {
                that.shop = res.data
                document.title = that.shop.shop_name
            })

            that.showEmpty = true
            that.showPopup = false
        },
        getGoodComboList() {
            let that = this
            this.$API.getGoodComboList({shop_id: this.shop_id, type: 'morning'}).then(res => {
                return res.data
            }).then(res => {
                let combo = res.data.combo
                let one = res.data.one
                that.comboList = combo
                this.getGoodList(one)
            })
            that.cart.forEach(v => {
                that.total = that.$number.numberPlus(that.total, v.price)
            })
        },
        xGoods(value, index) {
            let show = !value.show
            this.allHide()
            value.show = show
            this.comboList[index].price_list = value.price_list.raise
        },
        allHide() {
            // 隐藏其他弹出
            this.comboList.forEach(function (v1) {
                v1.list.forEach(function (v2) {
                    v2.show = false
                })
            })
        },
        v3Goods(vo, i3, key) {
            this.comboList[key].list[i3].price_list = vo
            this.comboList[key].price_list = vo.raise
            this.onPrice(key)
        },
        v3GoodsRaise(vo, i3_raise, key, i3) {
            this.comboList[key].price_list[i3_raise].active = !this.comboList[key].price_list[i3_raise].active
            this.comboList[key].list[i3].list.raise = this.comboList[key].price_list
            this.onPrice(key)
        },
        // 重新计算套餐价格
        onPrice(key) {
            let vo = this.comboList[key]
                , that = this
                , price = 0;
            vo.list.forEach(v1 => {
                v1.price_list.raise.forEach(vraise => {
                    if (vraise.active) {
                        price = that.$number.numberPlus(price, parseFloat(vraise.price))
                    }
                })
                price = that.$number.numberPlus(price, parseFloat(v1.price_list.price))
            })
            vo.price = that.$number.numberReduce(price, vo.discount);
        },
        addOneOk() {
            let that = this
                , raise = []
                , arr = {};
            arr.type  = 'one';
            arr.id    = that.onePop.id;
            arr.count = 1;
            arr.name  = that.onePop.name;
            arr.price = that.onePop.price;
            that.ballFlag = !that.ballFlag
            that.onePop.raise.forEach(item => {
                if (item.active) {
                    arr.price = that.$number.numberPlus(arr.price, parseFloat(item.price))
                    raise.push(item.id + '‡' + item.name + '‡' + item.price)
                }
            })
            arr.raise = raise.toString();
            if (that.cart === null) {
                that.cart = [];
            }
            that.cart.push(arr);

            that.goodsPrice()

            that.oneShow = false

            Notify({ type: 'success', message: '加入购物车成功',duration: 1000 });
        },
        addCombo(vo, e) {
            let arr = {};
            let that = this
            , list = []
            , raise = []
            , price = parseFloat('0');

            const rect=e.target.getBoundingClientRect()
            that.tt = rect.top;
            that.ll = rect.left;
            that.ballFlag = !that.ballFlag

            price = that.$number.numberReduce(price, vo.discount);
            arr.type  = 'combo';
            arr.id    = vo.id;
            arr.count = 1;
            arr.name  = vo.name;
            vo.list.forEach(v1 => {
                raise = [];
                v1.price_list.raise.forEach(vraise => {
                    if (vraise.active) {
                        price = that.$number.numberPlus(price, parseFloat(vraise.price))
                        raise.push(vraise.id + '‡' + vraise.name + '‡' + vraise.price)
                    }
                })
                list.push({
                    id: v1.price_list.id,
                    name: v1.price_list.name,
                    raise: raise.toString()
                });
                price = that.$number.numberPlus(price, parseFloat(v1.price_list.price))
            })
            arr.price  = price
            arr.subgoods = list;

            if (that.cart === null) {
                that.cart = [];
            }
            that.cart.push(arr);

            that.goodsPrice()

            Notify({ type: 'success', message: '加入购物车成功',duration: 1000 });
        },
        goodsPrice() {
            this.total = 0;
            this.cart.forEach(v => {
                this.total = this.$number.numberPlus(this.total, v.price)
            })
            setCookie('cart_' + this.shop_id, JSON.stringify(this.cart))
            setCookie('cart_time_' + this.shop_id, Math.round(new Date().getTime()/1000))
        },
        addOne(vo, e) {
            this.onePop = vo
            const rect=e.target.getBoundingClientRect()
            this.tt = rect.top;
            this.ll = rect.left;

            if (vo.raise.length > 0) {
                vo.raise.forEach(item => {
                    item.active = false
                })
                this.oneShow = true
            } else {
                this.addOneOk()
            }
        },
        onePopActive(index) {
            let that = this
            that.onePop.raise[index].active = !that.onePop.raise[index].active
            this.oneShow = false
            this.oneShow = true
        },
        get_list(value) {
            let that = this
            this.click_id = value.id
            that.food_tab.forEach(function (item) {
                if (item.id === value.id) {
                    item.active = 1
                } else {
                    item.active = 0
                }
            })
            this.allHide()
        },
        buy() {
            if (!this.cart) {
                Notify({ type: 'danger', message: '购物车为空' });
                return false;
            }
            if (this.total < this.shop.min_fee && this.coType === '2') {
                Notify({ type: 'danger', message: '未达到起送金额' });
                return false;
            }
            setCookie('shop_id', this.shop_id)
            this.$router.push({
                path: '/cart'
            })
        },

        // 动画钩子函数
        // 进入前状态
        beforeEnter (el) {
            el.style.transform = 'translate(0,0)'
        },
        // 进入中
        enter (el, done) {
            let rect = this.$refs.cart.getBoundingClientRect();
            console.log(rect)
            // 需要调用元素的offset操作,才有过渡的效果,否则会马上实现过渡
            el.style.transform = 'translate(' + (rect.left + 80 - this.ll) + 'px,' + (rect.top - this.tt) + 'px)'
            el.style.transition = "all 1s cubic-bezier(.4,-0.3,1,.68)"
            done()
        },
        // 进入后
        afterEnter () {
            this.ballFlag = !this.ballFlag
        },
    },
}
</script>

<style lang="less" scoped>
.ku-food {
    margin-bottom: 90px;

    .ball{
        position:absolute;
        width: 25px;
        height: 25px;
        background-color: #00f;
        border-radius:50%;
        z-index:999;
    }

    .ku-tab {
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 2001;
        .grid {
            .van-grid-item {
                font-size: 30px;
                line-height: 40px;
                overflow: hidden;

                /deep/ .van-grid-item__content {
                    padding: 10px 0 0 0;
                    background: #DDD5C2;
                    border-bottom: 8px solid #DC561A;

                    &::after {
                        border: 0;
                    }
                }

                span {
                    &:nth-child(1) {
                        width: 64px;
                        height: 80px;
                        font-weight: bold;
                        overflow: hidden;
                        color: #70675C;
                    }

                    &:nth-child(2) {
                        width: 100%;
                        height: 40px;
                        overflow: hidden;
                        color: #C7AD8F;
                    }
                }

                &.active {
                    /deep/ .van-grid-item__content {
                        background: #DC561A;
                    }

                    span {
                        &:nth-child(1) {
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
    .ku-combo {
        .grid {
            margin: 10px 0 0 0;
            display: block;
            height: 220px;
            position: relative;
            .s1 {
                float: left;
                width: 177px;
                height: 208px;
                padding: 4px 3px;
                border: 1px solid #DD5928;
                border-radius: 5px;
                position: relative;
                span {
                    color: #DD5928;
                    text-align: center;
                    display: block;
                    float: left;
                    font-size: 26px;
                    overflow: hidden;
                    position: absolute;
                    &:nth-child(1) {
                        width: 100%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        font-size: 30px;
                        top: 70px;
                    }
                    &:nth-child(2) {
                        width: 100%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        font-size: 30px;
                        top: 140px;
                    }
                    &:nth-child(3) {
                        width: 70%;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        font-size: 20px;
                        top: 2px;
                        left: 12%;
                        color: #fff;
                        border-radius: 13px;
                        padding: 0 5px;
                        background: #baa58c;
                    }
                    label {
                        font-size: 20px;
                        margin-right: 5px;
                    }
                }
            }

            .s2 {
                float: left;
                width: 562px;
                height: 220px;
                white-space: nowrap;
                overflow-x: scroll;
                overflow-y: hidden;
                text-align: left;
                .s-1 {
                    width: 165px;
                    height: 208px;
                    display: inline-block;
                    white-space: normal;
                    position: relative;
                    border: 1px solid #231815;
                    border-radius: 5px;
                    padding: 4px;
                    margin: 0 5px;
                    span {
                        display: inline-block;
                        width: 100%;
                        text-align: center;
                        font-size: 24px;
                        color: #231815;
                        &:nth-child(3) {
                            position: absolute;
                            width: 75px;
                            height: 30px;
                            top: 2px;
                            left: 55px;
                            background: #baa58c;
                            border-radius: 13px;
                            line-height: 30px;
                            color: #fff;
                            font-size: 20px;
                        }
                    }
                    .van-image {
                        width: 165px;
                        height: 165px;
                    }
                }
            }
            .s3 {
                width: 100%;
                position: absolute;
                top: 225px;
                left: 0;
                background: none;
                z-index: 1003;
                padding-bottom: 20px;
                .s3-goods {
                    width: 100%;
                    height: 230px;
                    white-space: nowrap;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    padding: 20px 0;
                    .s-1 {
                        width: 165px;
                        height: 210px;
                        display: inline-block;
                        white-space: normal;
                        position: relative;
                        border-radius: 5px;
                        padding: 6px;
                        margin: 0 5px;
                        background: #fff;
                        .van-image {
                            width: 165px;
                            height: 165px;
                        }
                        .van-icon {
                            position: absolute;
                            width: 60px;
                            height: 60px;
                            background: #DD5928;
                            text-align: center;
                            line-height: 60px;
                            border-radius: 60px;
                            font-size: 30px;
                            color: #fff;
                            left: 55px;
                            top: 55px;
                        }
                    }
                }
                .v3-raise {
                    position: relative;
                    .s-1 {
                        display: inline-block;
                        white-space: normal;
                        padding: 10px;
                        min-height: 60px;
                        span {
                            padding: 15px 20px;
                            background: #fff;
                            color: #333333;
                            border-radius: 5px;
                            font-size: 24px;
                            &.active {
                                background: #DD5928;
                                color: #ffffff;
                            }
                        }
                    }
                }
                .van-button {
                    width: 100px;
                    height: 100px;
                    font-size: 24px;
                    padding: 0;
                }
            }
        }
    }
    .back_a {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
    }
    .onePop {
        width: 100%;
        background: none;
        .s1 {
            color: #fff;
            position: relative;
            font-size: 30px;
            border: 1px solid #DD5928;
            border-radius: 5px;
            display: inline-block;
            padding: 3px 20px;
            margin: 10px auto;
        }
        .v3-raise {
            position: relative;
            padding-top: 20px;
            .s-1 {
                display: inline-block;
                white-space: normal;
                padding: 10px;
                min-height: 60px;
                span {
                    padding: 15px 20px;
                    background: #fff;
                    color: #333333;
                    border-radius: 5px;
                    font-size: 24px;
                    &.active {
                        background: #DD5928;
                        color: #ffffff;
                    }
                }
            }
        }
        .van-button {
            width: 100px;
            height: 100px;
            font-size: 24px;
            padding: 0;
            margin: 0 10px 20px 10px;
        }
    }
    .ku-list {
        .grid {
            .van-grid-item {
                margin-top: 10px;
                .van-image {
                    width: 216px;
                    height: 216px;
                }
                /deep/ .van-grid-item__content {
                    padding: 3px;
                    border: 3px solid #C2AE97;
                    margin: 5px;
                    border-radius: 5px;
                    width: 228px;
                    height: 286px;
                    display: inline-block;
                    &::after {
                        border: 0;
                    }
                }
                span {
                    font-size: 25px;
                    position: absolute;
                    left: 5px;
                    bottom: 10px;
                    height: 40px;
                    line-height: 40px;
                    &.title {
                        width: 120px;
                        text-align: left;
                        overflow: hidden;
                    }
                    &.price {
                        right: 5px;
                        left: auto;
                        font-size: 29px;
                        font-family: 'Microsoft YaHei',STXihei,MingLiu;
                        label {
                            font-size: 16px;
                        }
                    }
                }

                &.active {
                    /deep/ .van-grid-item__content {
                        border: 3px solid #E94337;
                    }
                }
                &.image_text {
                    .van-image {
                        display: none;
                    }
                    span {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        left: 0;
                        bottom: auto;
                        overflow: hidden;
                        text-align: center;
                        &.title {
                            top: 85px;
                        }
                        &.price {
                            top: 125px;
                            bottom: auto;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
    .buy {
        position: fixed;
        width: 100%;
        bottom: 0;
        text-align: center;
        div {
            display: inline-block;
        }
        .but-1 {
            width: 200px;
            height: 70px;
            line-height: 70px;
            background: #D32C26;
            font-size: 36px;
            color: #fff;
            border-radius: 5px;
            margin: 0 5px;
            &:nth-child(3) {
                background: #643B15;
            }
        }
        .cen {
            width: 300px;
            height: 70px;
            line-height: 70px;
            border-radius: 5px;
            background: #EA5514;
            font-size: 30px;
            color: #FFF100;
            .s1 {
                width: 48%;
                line-height: 35px;
                display: inline-block;
                float: left;
                span {
                    font-size: 28px;
                    display: block;
                    color: #fff;
                }
                label {
                    font-size: 24px;
                }
            }
            .no {
                span {
                    line-height: 70px;
                }
                label {
                    display: none;
                }
            }
            .s2 {
                width: 48%;
                font-size: 36px;
                display: inline-block;
            }
        }
    }
}
</style>
